'use client';

import Cookies from 'js-cookie';

// Set authentication token in a cookie
export const setAuthCookie = (token) => {
  if (!token) {
    return;
  }
  
  // Set the cookie with secure settings
  Cookies.set('auth-token', token, {
    expires: 1, // 1 day
    secure: process.env.NODE_ENV === 'production', // Secure in production
    sameSite: 'strict', // CSRF protection
    path: '/', // Available across the site
  });
};

// Remove authentication token from cookies
export const removeAuthCookie = () => {
  Cookies.remove('auth-token', { path: '/' });
};

// Get authentication token from cookies
export const getAuthCookie = () => {
  return Cookies.get('auth-token');
};